import React from "react";
import "./top-listing-headers.css";
import SearchFilterInput from "../../form-fields/search-filter-input";
import SimpleButton from "../../buttons/Simple-button";
import H2 from "../../typography/H2";
import SortIcon from "../../../assets/svgs/SortIcon";
import SingleDropdown from "../../singleDropdown/SingleDropdown";
import Chevren_downIcon from "../../../assets/svgs/Chevren_down";

interface ListingTopHeaderProps {
  PageHeading?: string;
  className?: string;
  ButtonName?: string;
  MobileButtonName?: string;
  showAddButton?: boolean;
  searchTerm: string;
  setSearchTerm: (term: string) => void;
  onClick?: () => void;
  handleSort: (sortDirection: "asc" | "desc") => void;
  currentSortDirection: "asc" | "desc";
  handleFilterChange: (filter: string) => void;
  filterOptions?: { title: string; count: number }[];
  activeFilter?:string,
  setActiveFilter?:(term:string)=>void
  isEntityTypeTenant?: boolean;
}
// isActive = props?.activeFilter === "New"

export default function ServiceRequestTopHeader({
  PageHeading,
  className = "",
  ButtonName,
  MobileButtonName,
  showAddButton = true,
  searchTerm,
  setSearchTerm,
  onClick,
  handleSort,
  currentSortDirection,
  handleFilterChange, // Add this line
  filterOptions = [],
  activeFilter,
  setActiveFilter,
  isEntityTypeTenant = false,
  
  
}: ListingTopHeaderProps) {
  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchTerm(e.target.value);
  };

  const handleFilterTabChange = (title: string) => {
    setActiveFilter?.(title);
    handleFilterChange(title); // Call the filter change handler
    // Implement filter logic here
  };
  const handleSortChange = () => {
    const newDirection = currentSortDirection === "asc" ? "desc" : "asc";
    handleSort(newDirection);
  };

  const isSimpleHeader = (!filterOptions.length) && showAddButton === false;
  const sortDirectionText = currentSortDirection === "asc" ? "A-Z" : "Z-A";

return (
  <div className={`top-listing-header ${className}`}>

    {/* TOP HEADER */}
    <div className="top-listing-header-top">
      <div className="top-listing-header-left">
      <H2 text={`${PageHeading || ""}`} />
        {ButtonName && showAddButton && (
          <div className="top-listing-header-button-mobile">
            <SimpleButton label={MobileButtonName || ButtonName} onClick={onClick} />
          </div>
        )}
      </div>

      {isSimpleHeader ? (
        <div className="search-sort-container">
          <SearchFilterInput
            placeholder="Search by Service Request"
            searchTerm={searchTerm}
            handleSearch={handleSearch}
          />
          <div className="sort-button" onClick={handleSortChange} role="button" tabIndex={0}>
            <span className="sort-text">Sort by: {sortDirectionText}</span>
            <SortIcon />
          </div>
        </div>
      ) : (
        ButtonName && showAddButton && (
          <div className="top-listing-header-button-desktop">
            <SimpleButton label={ButtonName} onClick={onClick} />
          </div>
        )
      )}
    </div>

    {/* FILTERS — sirf tab show hon jab available hon */}
    <div className="top-listing-header-filters">
        <div className="filter-options filters-desktop">
          {filterOptions.map((option, index) => (
            <button
              key={index}
              className={`filter-option${
                activeFilter === option.title ? " filter-option-active" : ""
              }`}
              onClick={() => handleFilterTabChange(option.title)}
            >
              {option.title} ({option.count})
            </button>
          ))}
        </div>

        <div className="search-sort-container">
          <SearchFilterInput
            placeholder="Search by Service Request"
            searchTerm={searchTerm}
            handleSearch={handleSearch}
          />
          <div className="filters-mobile">
            <SingleDropdown
              triggerText={activeFilter || "All"}
              triggerIcon={<Chevren_downIcon width={"18"} height={"18"} />}
              triggerIconPosition="right"
              menuItems={filterOptions.map((option) => ({
                label: `${option.title} (${option.count})`,
                action: () => handleFilterTabChange(option.title),
              }))}
            />
          </div>
          <div className="sort-button" onClick={handleSortChange} role="button" tabIndex={0}>
            <span className="sort-text">Sort by: {sortDirectionText}</span>
            <SortIcon />
          </div>
      </div>
    </div>
  </div>
);

}
